import config from '../config'
import { authorizedFetch }  from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const SHOW_AVAILABLE_DATE_FORM = 'SHOW_AVAILABLE_DATE_FORM'
export const CLOSE_ADD_AVAILABLE_DATE_FORM = 'CLOSE_ADD_AVAILABLE_DATE_FORM'
export const UPDATE_AVAILABLE_DATE_FIELD = 'UPDATE_AVAILABLE_DATE_FIELD'
export const UPDATE_AVAILABLE_DATE = 'UPDATE_AVAILABLE_DATE'
export const UPDATE_AVAILABLE_DATE_SUCCEDED = 'UPDATE_AVAILABLE_DATE_SUCCEDED'
export const DELETE_AVAILABLE_DATE = 'DELETE_AVAILABLE_DATE'
export const DELETE_AVAILABLE_DATE_SUCCEDED = 'DELETE_AVAILABLE_DATE_SUCCEDED'

export const showUpdateAvailableDateForm = (availableDate) => ({
  type: SHOW_AVAILABLE_DATE_FORM,
  availableDate: availableDate
})

export const closeAddAvailableDateForm = () => ({
  type: CLOSE_ADD_AVAILABLE_DATE_FORM,
})

export const updateAvailableDateField = (name, value) => ({
  type: UPDATE_AVAILABLE_DATE_FIELD,
  name: name,
  value: value
})

export const updateAvailableDate = (availableDate) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'locations/availableDate/update',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({availableDate: availableDate})
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateAvailableDateSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const updateAvailableDateSucceded = (location) => ({
  type: UPDATE_AVAILABLE_DATE_SUCCEDED,
  location: location
})

export const deleteAvailableDate = (availableDate) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'locations/availableDate/delete',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ availableDate : availableDate })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteAvailableDateSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const deleteAvailableDateSucceded = (location) => ({
  type: DELETE_AVAILABLE_DATE_SUCCEDED,
  location: location
})



// WEBPACK FOOTER //
// ./src/actions/availableDates.js